var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRollOverInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 5,
    fill: "white",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.879 8.121C3.59247 7.84426 3.36392 7.51323 3.2067 7.14721C3.04947 6.7812 2.96671 6.38754 2.96325 5.9892C2.95979 5.59087 3.03569 5.19583 3.18653 4.82714C3.33738 4.45845 3.56014 4.12349 3.84181 3.84181C4.12349 3.56014 4.45845 3.33738 4.82714 3.18653C5.19583 3.03569 5.59087 2.95979 5.9892 2.96325C6.38754 2.96671 6.7812 3.04947 7.14721 3.2067C7.51323 3.36392 7.84426 3.59247 8.121 3.879C8.66747 4.44481 8.96986 5.20261 8.96302 5.9892C8.95619 6.77579 8.64068 7.52823 8.08446 8.08446C7.52823 8.64068 6.77579 8.95619 5.9892 8.96302C5.20261 8.96986 4.44481 8.66747 3.879 8.121ZM7.698 7.698C8.14834 7.24766 8.40133 6.63687 8.40133 6C8.40133 5.36313 8.14834 4.75234 7.698 4.302C7.24766 3.85166 6.63687 3.59866 6 3.59866C5.36313 3.59866 4.75234 3.85166 4.302 4.302C3.85166 4.75234 3.59866 5.36313 3.59866 6C3.59866 6.63687 3.85166 7.24766 4.302 7.698C4.75234 8.14834 5.36313 8.40133 6 8.40133C6.63687 8.40133 7.24766 8.14834 7.698 7.698ZM5.7 6.3V5.7H6.3V7.5H5.7V6.3ZM5.7 4.5H6.3V5.1H5.7V4.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRollOverInfo);
export default __webpack_public_path__ + "static/media/rollOverInfo.0d7528d0ce56c868927ab032be620871.svg";
export { ForwardRef as ReactComponent };